import { observer } from 'mobx-react';
import { FC, ReactElement } from 'react';
import Message from './components/Message/Message';
import { messagesStore } from './store/messages';

const Messages: FC = observer((): ReactElement => {
  return (
    <div>
      {messagesStore.messages.map((data) => (
        <Message key={data.id} data={data} />
      ))}
    </div>
  );
});

export default Messages;
